import Pager from '@/components/PagerComponent'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import { Schemes } from '@/enums/schemes.enum'
import { TransactionCategories } from '@/enums/transaction-categories.enum'
import { BeneficiaryServiceStatus } from '@/enums/beneficiary-service-status.enum'

import { useToast } from 'vue-toast-notification';

export default {

  components: {
    Pager
  },

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      criterias: {
        selectedDistributorRef: '',
        selectedCommercialProduct: '',
        selectedFunderContract: '',
        selectedBeneficiaryService: '',
        selectedBeneficiaryServiceStatus: '',
        selectedCreationDate: null,
        selectedClosingDate: null
      },
      displayedBeneficiaryServices: [],
      distributors: [],
      comProducts: [],
      responseErr: '',
      error: false,
      validationError: false,
      isProcessing: false,
      schemes: Schemes,
      transactionClasses: TransactionCategories,
      beneficiaryServiceStatus: BeneficiaryServiceStatus,
      isDistributorLocked: false
    }
  },

  created () {
    if(this.$store.state.beneficiaries.invalidData) {
      const $toast = useToast();
      $toast.open({
        message: this.$i18n.t('error.' + this.$store.state.beneficiaries.invalidData),
        type:'default',
        position: 'bottom',
        duration: 5000,
        dismissible:true
      });
    }
    this.$store.dispatch('products/resetInvalidData')
    const user = JSON.parse(sessionStorage.getItem('user'))
    this.getDistributors(user)
    this.getProducts(user)
    this.getCriterias(user)
  },

  methods: {
    search () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.$store.dispatch('beneficiaries/setCriterias', this.criterias)
        this.getBeneficiarys()
      }
    },

    async getDistributors (user) {
      this.distributors = Object.keys(user.comProductsMap).sort()
      if (user.ihmDistribRef) {
        this.criterias.selectedDistributorRef = user.ihmDistribRef
        this.isDistributorLocked = true
      }
    },

    async getProducts (user) {
      for (const tmpPprdcRefList of Object.values(user.comProductsMap)) {
        this.comProducts = this.comProducts.concat(Object.values(tmpPprdcRefList)[0])
      }
      this.comProducts.sort((a, b) => a.localeCompare(b))
    },

    async getCriterias (user) {
      if(this.$store.state.beneficiaries.criterias && this.$store.state.beneficiaries.beneficiaries.length > 0) {
        this.criterias = this.$store.state.beneficiaries.criterias
      }
      if (user.ihmDistribRef) { // Au cas où le distributeur serait changé
        this.criterias.selectedDistributorRef = user.ihmDistribRef
      }
    },

    updateComProducts () {
      const user = JSON.parse(sessionStorage.getItem('user'))
      this.comProducts = Object.values(user.comProductsMap[this.criterias.selectedDistributorRef])[0]
      this.comProducts.sort((a, b) => a.localeCompare(b))
    },

    getIssuerId (distrRef) {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return Object.keys(user.comProductsMap[distrRef])[0]
    },

    async getBeneficiarys () {
      this.isProcessing = true
      this.error = false

      await this.$store.dispatch('beneficiaries/reset')
      await this.$store.dispatch('beneficiaries/search', {
        distributorRef: this.criterias.selectedDistributorRef,
        issuerId: this.getIssuerId(this.criterias.selectedDistributorRef),
        productRef: this.criterias.selectedCommercialProduct,
        funderContractRef: this.criterias.selectedFunderContract,
        beneficiaryServiceRef: this.criterias.selectedBeneficiaryService,
        beneficiaryState: this.criterias.selectedBeneficiaryServiceStatus,
        creationDate: this.criterias.selectedCreationDate,
        closingDate: this.criterias.selectedClosingDate
      }).then(
        () => {
          this.isProcessing = false
        },
        error => {
          this.isProcessing = false
          this.error = true
          this.responseErr = (error || 'BAD_REQUEST').toUpperCase()
        }
      )
    },

    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },

    async showDetails (beneficiaryService) {
      this.$store.dispatch('beneficiaries/setBeneficiaryService', beneficiaryService)
      this.$router.push({ name: 'beneficiaryservice-detail' })
    },

    reset () {
      this.$store.dispatch('beneficiaries/reset')
      this.$store.dispatch('beneficiaries/resetCriterias')
      this.validationError = false
      this.error = false
      if (!this.isDistributorLocked) {
        this.criterias.selectedDistributorRef = ''
      }
      this.criterias.selectedCommercialProduct = ''
      this.criterias.selectedFunderContract = ''
      this.criterias.selectedBeneficiaryService = ''
      this.criterias.selectedBeneficiaryServiceStatus = ''
      this.criterias.selectedCreationDate = null
      this.criterias.selectedClosingDate = null
    }
  },

  validations () {
    return {
      criterias: {
        selectedDistributorRef: { required },
        selectedCommercialProduct: {},
        selectedFunderContract: {},
        selectedBeneficiaryService: {},
        selectedBeneficiaryServiceStatus: {},
        selectedCreationDate: {},
        selectedClosingDate: {}
      }
    }
  }
}
